namespace Ir.Components.DrilldownReports.DrilldownReports {
    export interface IViewModel {
        gridConfig: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;

        reports: Array<ReportStub>;
    }

    interface IParams {
        mappingId: number;
        callback: (obj: any) => { };
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        load(this, params);
        let forceReloadDropdown = ko.observable(true); //Hack to reload dropdown items     
        let saveCancelDisabled = ko.observable(true);

        const mapping = MappingService.getMapping(params.mappingId);

        params.callback({
            reloadDrilldown() {
                mapping.forceReloadDrilldowns();
                load(self, params);
                self.gridComponent.option("dataSource", self.reports);
                forceReloadDropdown(!forceReloadDropdown());
            }
        });

        let self = this;
        this.gridConfig = {
            keyExpr: "id",
            rowAlternationEnabled: false,
            dataSource: self.reports,
            columns: [
                {
                    dataField: "order",
                    visible: false
                },
                {
                    dataField: "name",
                    allowEditing: false
                },
                {
                    type: "buttons",
                    buttons: [{
                        hint: "Delete",
                        icon: "trash",
                        onClick: function (e) {
                            const index = self.reports.findIndex(x => x.id === e.row.data.id);
                            if (index !== -1) {
                                self.reports.splice(index, 1);
                            }

                            self.gridComponent.option("dataSource", self.reports);
                            forceReloadDropdown(!forceReloadDropdown());
                            saveCancelDisabled(false);
                        }
                    }]
                }
            ],
            editing: {
                confirmDelete: false,
                newRowPosition: "last"
            },
            toolbar: {
                items: [
                    {
                        cssClass: "customAddRowDataGridAdmin", location: "before",
                        widget: 'dxDropDownButton',
                        options: {
                            displayExpr: "name",
                            items: ko.computed(() => {
                                forceReloadDropdown();                                
                                const parentIds = mapping.visibleOriginalReports.map(item => item.parentItemId).filter(x => x !== 0);
                                const templates = mapping.visibleOriginalReports.filter(item =>
                                    item.parentItemId !== 0 || parentIds.indexOf(item.id) === -1
                                );

                                return templates.filter(x => !self.reports.find(r => r.id === x.id));;

                            }),
                            dropDownOptions: {
                                hideOnOutsideClick: true,
                                showCloseButton: false,
                                width: 220,
                                toolbarItems: [{
                                    widget: "dxButton",
                                    location: "after",
                                    options: {
                                        icon: "ms ir-sort-by-alpha-icon",
                                        hint: "Sort alphabetically",
                                        elementAttr: {
                                            class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                                        },
                                        onClick(e) {
                                            loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                                            if (e.element.hasClass("selected")) {
                                                e.element.removeClass("selected");
                                            }
                                            else {
                                                e.element.addClass("selected");
                                            }

                                            forceReloadDropdown(!forceReloadDropdown());
                                        }
                                    }
                                }]
                            },
                            text: 'Add Report',
                            icon: 'add',
                            onItemClick(e) {                             
                                let maxOrder = Math.max(...self.reports.map(x => x.order));
                                let newReport = { ...e.itemData };
                                newReport.order = maxOrder === 0 ? 0 : maxOrder + 1;

                                self.reports.push(newReport);
                                self.gridComponent.option("dataSource", self.reports);
                                forceReloadDropdown(!forceReloadDropdown());
                                saveCancelDisabled(false);
                            }
                        },
                    },
                    {
                        cssClass: "customButtonDataGridAdmin saveButton", location: "before",
                        widget: 'dxButton',
                        options: {
                            icon: "save",
                            text: 'Save',
                            onClick(e) {
                                let o = {
                                    url: `${urlConfigs.drilldownReport}Save`,
                                    data: { mappingId: params.mappingId, reports: self.reports.map(x => x.id) },
                                    dataType: "json",
                                    async: false,
                                } as RequestServerParams;
                                o.successFunction = function () {
                                    saveCancelDisabled(true);
                                };
                                o.failureFunction = function (textStatus, failureText, errorItem: IError) {
                                    errorItem.userMessage = `Failed to get the mapping reports`;
                                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
                                };

                                irGlobal.requestServer(o);
                            },
                            disabled: saveCancelDisabled
                        }
                    }, {
                        cssClass: "customButtonDataGridAdmin cancelButton", location: "before",
                        widget: 'dxButton',
                        options: {
                            text: 'Cancel',
                            icon: 'close',
                            onClick(e) {
                                load(self, params);
                                self.gridComponent.option("dataSource", self.reports);
                                forceReloadDropdown(!forceReloadDropdown());
                                saveCancelDisabled(true);
                            },
                            disabled: saveCancelDisabled
                        }
                    },
                    { name: "searchPanel", location: "after" }
                ]
            },
            scrolling: {
                useNative: false
            },
            searchPanel: {
                visible: true,
                placeholder: 'Search...',
                searchVisibleColumnsOnly: true
            },
            paging: {
                enabled: false
            },
            sorting: {
                mode: 'none',
            },
            rowDragging: {
                allowReordering: true,
                dropFeedbackMode: 'push',
                onReorder(e) {
                    const visibleRows = e.component.getVisibleRows();
                    const toIndex = self.reports.findIndex((item) => item.id === visibleRows[e.toIndex].data.id);
                    const fromIndex = self.reports.findIndex((item) => item.id === e.itemData.id);

                    self.reports.splice(fromIndex, 1);
                    self.reports.splice(toIndex, 0, e.itemData);

                    let order = 0;
                    for (let drilldown of self.reports) {
                        drilldown.order = ++order;
                    }

                    e.component.refresh();

                    saveCancelDisabled(false);
                },
            },
            onInitialized(e) {
                self.gridComponent = e.component;
            },
            onCellPrepared(e) {
                if (e.column.dataField === "name" && e.data) {
                    let report = e.data as ReportStub;
                    if (report.visibility === VisibilityEnum.Deprecated) {
                        e.cellElement.addClass("deprecated");
                    }
                }

                if (e.rowType === "data" && e.rowIndex % 2 === 0) {
                    e.cellElement.addClass("ir-row-alternation-color");
                }
            },
            onOptionChanged(e) {
                if (e.name === "searchPanel" && e.fullName === "searchPanel.text" && self.gridComponent) {
                    self.gridComponent.option("rowDragging.allowReordering", e.value ? false : true);
                }
            }
        } as any;
    }

    function load(self: IViewModel, params: IParams) {
        const mapping = MappingService.getMapping(params.mappingId);
        self.reports = [...mapping.drilldowns];
    }
}